var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.participantScores && _vm.scoreDef)?_c('div',{staticClass:"report-total-score-light text-center"},[_c('b-badge',{attrs:{"v-if":_vm.risk,"variant":_vm.risk ? _vm.risk.variant : null}},[_vm._v("\n        "+_vm._s(_vm.risk ? _vm.$i18n.gt(_vm.risk.label) : null)+"\n    ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }